export default __webpack_public_path__ + "static/media/subscription-white.afffc162.svg";